export const ICONS = {
  square: {
    viewBox: '0 0 176 31',
    path:
      'M1.64386 15.5L1.64386 2.16H18.9151V15.5V25.505H36.1863V15.5V5.495H53.4576V15.5V30H70.7288V15.5V1H88V15.5V27.39H105.271V15.5V3.61H122.542V15.5V25.505H139.814V15.5V5.495H157.085V15.5V29.42H174.356V15.5',
  },
  sine: {
    viewBox: '0 0 176 31',
    path:
      'M1.64386 15.5C7.40094 -3.83333 13.158 -3.83333 18.9151 15.5C24.6722 34.8333 30.4292 34.8333 36.1863 15.5C41.9434 -3.83333 47.7005 -3.83333 53.4576 15.5C59.2146 34.8333 64.9717 34.8333 70.7288 15.5C76.4859 -3.83333 82.2429 -3.83333 88 15.5C93.7571 34.8333 99.5142 34.8333 105.271 15.5C111.028 -3.83333 116.785 -3.83333 122.542 15.5C128.3 34.8333 134.057 34.8333 139.814 15.5C145.571 -3.83333 151.328 -3.83333 157.085 15.5C162.842 34.8333 168.599 34.8333 174.356 15.5',
  },
  triangle: {
    viewBox: '0 0 177 30',
    path:
      'M1.76715 27L14.5579 3L27.3487 27L39.2258 3L52.0166 27L63.8938 3L76.6845 27L88.5617 3L100.896 27L113.23 3L125.564 27L137.897 3L150.688 27L163.022 3L175.356 27',
  },
  sawtooth: {
    viewBox: '0 0 175 28',
    path:
      'M0.64386 26L35.2812 2V26L69.9186 2V26L105.03 2V26L138.719 2V26L173.356 2V26',
  },
};
